import { useMonitorOutput } from './useMonitorOutput.js';
export function useCollectedProps(collector, monitor, connector) {
  return useMonitorOutput(monitor, collector || (() => ({})), () => connector.reconnect());
}